import React, { Component } from "react";
import { Menu } from "antd";
import { Drawer, Button } from "antd";
import { DEPLOYMENT_ENVIRONMENT } from '../constants/index';
import {
  MenuOutlined
} from '@ant-design/icons';


class Navbar extends Component {
  state = {
    current: "mail",
    visible: false
  };
  showDrawer = () => {
    this.setState({
      visible: true
    });
  };
  onClose = () => {
    this.setState({
      visible: false
    });
  };


  render() {
    let internallink;
    if (DEPLOYMENT_ENVIRONMENT == 'internal') {
        internallink =  <Menu.Item key="redocinternal"><a href="compassinternal">Redoc API internal documentation</a></Menu.Item>;
    } 


    return (
      <nav className="menuBar">
        <div className="logo">
          <a href="/"><img src="/sabinet-logo.png" alt="image" /></a>
        </div>
        <div className="menuCon">
          <Button className="barsMenu" type="primary" onClick={this.showDrawer}>
               <MenuOutlined />
          </Button>
          <Drawer
            title="Compass API sections"
            placement="right"
            closable={true}
            onClose={this.onClose}
            visible={this.state.visible}
          >
      <Menu mode="vertical">
        <Menu.Item key="app">
          <a href="/">Start here</a>
        </Menu.Item>
        <Menu.Item key="aap">
          <a href="access">Accessing the API</a>
        </Menu.Item>
        <Menu.Item key="redoc">
          <a href="compass">Redoc API documentation</a>
        </Menu.Item>
        {internallink}
        <Menu.Item key="sb">
          <a href="searchexamples">Search Basics</a>
        </Menu.Item>
        <Menu.Item key="sf">
          <a href="search">Search Fields</a>
        </Menu.Item>
      </Menu>
          </Drawer>
        </div>
      </nav>
    );
  }
}
export default Navbar;
